interface City {
  id: number;
  name: string;
  city_name?: string;
  country: number;  // Foreign key to Country (ID)
  country_details?: Country;  // The expanded Country object (when included)
}

interface Country {
  id: number | string;
  name?: string;
  country_name?: string;
  code: string;
  region?: string;  // Optional region field
}

// Enum types matching Django choices
export enum LocationTypeEnum {
  COUNTRY = 'COUNTRY',
  REGION = 'REGION',
  STATE = 'STATE',
  CITY = 'CITY',
  REMOTE = 'REMOTE'
}

export enum RegionEnum {
  EMEA = "EMEA",
  EUROPE = "EUROPE",
  NORTH_AMERICA = "NORTH_AMERICA"
}

// US States enum (abbreviated version - you can expand as needed)
export enum USStateEnum {
  AL = "AL",
  AK = "AK",
  AZ = "AZ",
  AR = "AR",
  CA = "CA",
  CO = "CO",
  CT = "CT",
  DE = "DE",
  DC = "DC",
  FL = "FL",
  GA = "GA",
  HI = "HI",
  ID = "ID",
  IL = "IL",
  IN = "IN",
  IA = "IA",
  KS = "KS",
  KY = "KY",
  LA = "LA",
  ME = "ME",
  MD = "MD",
  MA = "MA",
  MI = "MI",
  MN = "MN",
  MS = "MS",
  MO = "MO",
  MT = "MT",
  NE = "NE",
  NV = "NV",
  NH = "NH",
  NJ = "NJ",
  NM = "NM",
  NY = "NY",
  NC = "NC",
  ND = "ND",
  OH = "OH",
  OK = "OK",
  OR = "OR",
  PA = "PA",
  RI = "RI",
  SC = "SC",
  SD = "SD",
  TN = "TN",
  TX = "TX",
  UT = "UT",
  VA = "VA",
  WA = "WA",
  WV = "WV",
  WI = "WI",
  WY = "WY",
}

// City interface
interface City {
  id: number;
  city_name?: string;
}

// Country interface
interface Country {
  id: number | string;
  country_name?: string;
}

// Main AllowedLocation interface
interface AllowedLocation {
  id: number;
  city: number | null;
  city_details: City | null;
  country: number | null;
  country_details: Country | null;
  location_type: LocationTypeEnum;
  region: RegionEnum | null;
  us_state: USStateEnum | null;
  location_name: string;
}

// Interface for API response
interface AllowedLocationResponse {
  count: number;
  next: string | null;
  previous: string | null;
  results: AllowedLocation[];
}

// Interface for location filters
interface LocationFilters {
  country_id?: number;
  region?: RegionEnum;
  location_type?: LocationTypeEnum;
  us_state?: USStateEnum;
}

export type { City, Country, AllowedLocation, AllowedLocationResponse, LocationFilters };